import { Injectable } from '@angular/core';
import { WaitingAchievement } from '../utils/WaitingAchievement';

@Injectable({
  providedIn: 'root'
})
export class AchievementService {

	public static BEST_TIME:string = "BEST_TIME";
	public static BEST_POINTS:string = "BEST_POINTS";
	
	private waitingAchievement:WaitingAchievement;

	public setWaitingAchievement(waiting:WaitingAchievement){
		this.waitingAchievement = waiting;
	}
	public getWaitingAchievement():WaitingAchievement{
		return this.waitingAchievement;
	}

	public isBothAchievement():boolean{
		if(this.getWaitingAchievement() != null){
			return this.getWaitingAchievement().isBothAchievement();
		}else{
			return false;
		}
	}
		private achievements:Map<string, Map<string, string>>;
		
		public constructor()
		{
			this.achievements = new Map<string, Map<string, string>>();
		}
		
		public getAchievement( type:string, achievementType:string ):string {
			if ( this.achievements[ type ] == null ) {
				return " - ";
			}
			if ( this.achievements[ type ][ achievementType ] == null ) {
				return " - ";
			}
			return this.achievements[ type ][ achievementType ];
		}
		
		public updateAllAchievements( achievements:Array<string>, startIdx:number = 0 ):void {
			if ( achievements.length == 1 ) {
				return;
			}
			for ( var i:number = startIdx; i < achievements.length; i += 3 ) {
				var type:string = achievements[ i ];
				var achievementType:string = achievements[ i + 1 ];
				var achievement:string = achievements[ i + 2 ];
				this.updateAchievement( type, achievementType, achievement );
			}
		}
		
		public updateAchievement( type:string, achievementType:string, achievement:string ):void {
			if ( this.achievements[ type ] == null ) {
				this.achievements[type ] = new Map<string, string>();
			}
			this.achievements[ type ][ achievementType ] = achievement;
    }  
  
}
